// src/features/editor/extensions/Stepper/components/StepperItemMenu.tsx
import { FloatingMenu, useEditorState } from '@tiptap/react'
import { MenuProps } from 'features/editor/components/menus/types'
import { useCallback } from 'react'

export const StepperItemMenu = ({ editor, appendTo }: MenuProps) => {
  const shouldShow = useCallback(({ editor }) => {
    return editor.isActive('stepperItem')
  }, [])

  // const handleStatusChange = useCallback((value: string) => {
  //   editor
  //     .chain()
  //     .focus()
  //     .command(({ tr, dispatch }) => {
  //       if (dispatch) {
  //         const { from, to } = editor.state.selection
  //         tr.setNodeAttribute(from, 'status', value)
  //       }
  //       return true
  //     })
  //     .run()
  // }, [editor])
  const handleStatusChange = useCallback((value: string) => {
    editor
      .chain()
      .focus()
      .updateAttributes('stepperItem', { status: value })
      .run()
  }, [editor])

  if (!editor) return null


  const { status } = useEditorState({
    editor,
    selector: ctx => {
      return {
        status: ctx.editor.getAttributes('stepperItem').status || 'pending'
      }
    },
  })

  return (
    <FloatingMenu
      editor={editor}
      shouldShow={shouldShow}
      tippyOptions={{
        // popperOptions: {
        //   modifiers: [{ name: 'flip', enabled: false }],
        // },
        appendTo: appendTo?.current || 'parent',
        placement: 'right'
      }}
    >
      <div className="flex items-center gap-2 p-2 bg-white shadow rounded">
        <select
          value={status}
          onChange={(e) => handleStatusChange(e.target.value)}
        >
          <option value="completed">Aprovado</option>
          <option value="canceled">Rejeitado</option>
          <option value="working">Onde está</option>
          <option value="pending">Próximos passos</option>
        </select>
      </div>
    </FloatingMenu>
  )
}